import { useEffect, useState } from 'react';

/**
 * 控制操作按钮的淡入淡出
 * @returns
 */
export const useFadeNodeHelper = () => {
    const [hidden, setHidden] = useState(false);
    const [timeHandler, setTimeHandler] = useState<number>();

    useEffect(() => {
        const handler = window.setTimeout(() => {
            setHidden(false);
        }, 100);
        setTimeHandler(handler);
        return () => {
            window.clearTimeout(handler);
        };
    }, []);

    return {
        hide() {
            if (timeHandler) {
                window.clearTimeout(timeHandler);
                setTimeHandler(undefined);
            }
            setHidden(true);
        },
        show() {
            setHidden(false);
        },
        opacity: hidden ? 0 : 1,
    };
};

/**
 * 判断元素是否可由 Canvas drawImage 直接消费。
 *
 * @param el - 当前正式图层资源。
 * @returns image 或 canvas 返回 true。
 */
export const isDrawableElement = (el: unknown): el is HTMLImageElement | HTMLCanvasElement =>
    el instanceof HTMLImageElement || el instanceof HTMLCanvasElement;
